import { axiosGet } from '../axios/config';

export const getUserVerificationData = (data) => {
  return axiosGet(`/verification/fetch_data`, data);
};
